<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <i-input prefix="ios-search" placeholder="输入关键词查询" v-model="search.sname" style="width: auto;margin-left: 1em" />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="标题：" prop="topic">
          <i-input v-model="formValidate.topic" placeholder="输入标题"></i-input>
        </FormItem>

        <FormItem label="上传（文件/照片）：" prop="fileUrl">
          <div class="form_upload">
            <Upload multiple type="drag" action="/api/upload?dir=solidWasteAudit" :on-success="upImgSuccess"
              :on-remove="handleRemove" :with-credentials="true">
              <div style="padding: 20px 0;background: #E6EFFF;">
                <img src="@/assets/photo.png" alt="">
                <p style="color: #165DFF;font-size: 14px;">上传文件或照片</p>
              </div>
            </Upload>
          </div>
          <div>
            <ul>
              <li v-for="(item, index) in formValidate.fileUrl" :key="index"><span class="del_file"
                  @click="removeFile(index)">X</span> {{ item.name
                  }}</li>
            </ul>
          </div>
        </FormItem>
        <FormItem label="备注/说明：" prop="content">
          <i-input v-model="formValidate.content" type="textarea" :rows="2" placeholder="输入备注/说明"></i-input>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.del_file {
  color: red;
  cursor: pointer;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import LoadImg from "../../../components/Load_img.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "标题",
            key: "topic",
            align: "center",
          },
          {
            title: "附件",
            key: "fileUrl",
            align: "center",
            render(h, params) {
              const iconPaths = {
                ai: '/icons/32/ai.gif',
                avi: '/icons/32/avi.gif',
                bmp: '/icons/32/bmp.gif',
                cs: '/icons/32/cs.gif',
                dll: '/icons/32/dll.gif',
                doc: '/icons/32/doc.gif',
                wps: '/icons/32/doc.gif',
                docx: '/icons/32/docx.gif',
                exe: '/icons/32/exe.gif',
                fla: '/icons/32/fla.gif',
                gif: '/icons/32/gif.gif',
                jpg: '/icons/32/jpg.gif',
                png: '/icons/32/jpg.gif',
                js: '/icons/32/js.gif',
                mdb: '/icons/32/mdb.gif',
                mp3: '/icons/32/mp3.gif',
                pdf: '/icons/32/pdf.gif',
                ppt: '/icons/32/ppt.gif',
                pptx: '/icons/32/pptx.gif',
                rdp: '/icons/32/rdp.gif',
                swf: '/icons/32/swf.gif',
                swt: '/icons/32/swt.gif',
                txt: '/icons/32/txt.gif',
                vsd: '/icons/32/vsd.gif',
                xls: '/icons/32/xls.gif',
                xlsx: '/icons/32/xlsx.gif',
                xml: '/icons/32/xml.gif',
                zip: '/icons/32/zip.gif'
              };
              if (params.row.fileUrl == "") return "";
              const fileUrlData = JSON.parse(params.row.fileUrl); // 解析 JSON 字符串  
              return h(
                "div",
                {
                  style: {
                    height: "50px",
                    overflow: "hidden"
                  }
                },
                fileUrlData.map((item) => {
                  // 显示每个对象的 name 属性  
                  return h(
                    "a",
                    {
                      attrs: {
                        href: item.response,
                        target: "_blank"
                      },
                      style: {
                        display: "inline-block",
                        lineHeight: "50px"
                      }
                    },
                    [
                      h("img", {
                        attrs: {
                          src: iconPaths[item.name.split('.').pop().toLowerCase()] || "/icons/32/default.icon.gif", // 获取扩展名对应的图标路径，如果没有对应的图标则使用默认图标路径  
                          width: "20px", // 设置图标的宽度  
                          height: "20px", // 设置图标的高度  
                          title: item.name // 显示 item.name 作为链接文本，与图标一起显示  
                        },
                        style: {
                          marginRight: "5px", // 设置图标与链接文本之间的间距  
                          verticalAlign: "middle" // 使图标与链接文本垂直居中对齐  
                        }
                      }),
                    ]
                  );
                })
              );
            }
          },
          {
            title: "备注/描述",
            key: "content",
            align: "center",
            width: 300,
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm:ss"))
              ]);
            }
          },
          {
            title: "修改时间",
            key: "updateDate",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.updateDate, "yyyy-MM-dd HH:mm:ss"))
              ]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          topic: params.row.topic, // 标题
                          fileUrl: (params.row.fileUrl.length > 0) ? JSON.parse(params.row.fileUrl) : [], // 附件
                          content: params.row.content, // 备注信息
                        };
                        //getFileList(fileUrl);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        sname: null // 企业名
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        topic: "", // 标题
        fileUrl: [], // 附件
        content: "", // 备注信息
      },
      // 验证
      ruleValidate: {
        topic: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
    };
  },
  components: {
    toolbar,
    LoadImg
  },
  created() {
    this.getData(); // 数据初始化
  },
  methods: {
    upImgSuccess(res, file) {
      if (!res.code) {
        if (typeof (this.formValidate.fileUrl) == 'string')
          this.formValidate.fileUrl = JSON.parse(this.formValidate.fileUrl);
        this.formValidate.fileUrl.push(file);
      } else {
        this.$Notice.warning({
          title: "上传失败",
          desc: res.message
        });
      }
    },
    removeFile(index) {
      this.formValidate.fileUrl.splice(index, 1); // 使用splice方法从数组中删除指定索引的元素  
    },
    handleRemove(res) {
      this.formValidate.fileUrl.splice(
        this.formValidate.fileUrl.findIndex(item => item.response === res.response),
        1
      )
    },
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        topic: "", // 标题
        fileUrl: [], // 附件
        content: "", // 备注信息
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Info.getEnvironmentalEmergencyPlanList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Info.postEnvironmentalEmergencyPlanDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Info.postEnvironmentalEmergencyPlanAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Info.postEnvironmentalEmergencyPlanEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    imgLoadDel() {
      this.formValidate.permitImage = null;
    },
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.permitImage = url;
    },
  }
};
</script>